<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Reset Password</h1>
                <p class="text-muted">新しいパスワードを設定</p>
                <CInput
                  v-model="user.password"
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password">
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  v-model="user.password_repeat"
                  placeholder="Repeat password"
                  type="password"
                  autocomplete="new-password"
                  class="mb-4">
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CButton 
                  color="success"
                  size="lg"
                  @click="send()"
                  block>
                  Set Password</CButton>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      user:{
        password: "",
        password_repeat: "",
      }
    }
  },
  methods: {
    send () {      
      if(this.user.password == this.user.password_repeat){
        let api = new ApiService();
        api.resetPassword(this.user,this.$route.params.token)
          .then((response) => {
            this.$swal('変更完了', "パスワードリセットを更新しました", 'success')
              .then(() => {
                this.$router.push({path: "/app/color/login"});
              });
          })
          .catch((error) => {
            this.$swal('エラー', "パスワードリセットの期限が切れています", 'error');
          });
      }else{
        this.$swal('エラー', "パスワードが一致していません", 'error');
      }
    }
  }
}
</script>
